import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream">
      <div className="text-brand-navy font-medium">Se încarcă…</div>
    </div>
  );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
